import React from 'react';
import { Link } from 'react-router-dom';
import reviter from '../../assets/reviter.png';
import { MessageCircle, Mail, Globe } from 'lucide-react';
import PoweredBy from '../common/PoweredBy';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-primary-dark/90 via-primary-dark to-primary-dark/95 text-white">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-end gap-1 mb-4">
              <img src={reviter} alt="Logotipo Reviter" className="h-10 w-max" />
              <span className="text-3xl font-extrabold bg-gradient-to-br from-primary-light to-white bg-clip-text text-transparent tracking-tight">
                Reviter
              </span>
            </Link>
            <p className="text-gray-300 mb-5 max-w-md text-sm leading-relaxed">
              Plataforma whitelabel pra fornecedores e revendedores. Catálogo, pagamentos
              integrados, split com revendedores e domínio próprio — em uma só conta.
            </p>
            <a
              href="mailto:contato@reviter.com.br"
              className="inline-flex items-center gap-2 text-sm text-gray-200 hover:text-white transition-colors mb-4"
            >
              <Mail size={16} /> contato@reviter.com.br
            </a>
            <div className="flex gap-2 text-gray-300">
              <a
                href="#whatsapp"
                aria-label="WhatsApp"
                className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <MessageCircle size={18} />
              </a>
              <a
                href="#site"
                aria-label="Site"
                className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <Globe size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
            <div>
              <h3 className="font-bold mb-3 text-sm uppercase tracking-wider text-white/80">
                Plataforma
              </h3>
              <ul className="space-y-2 text-sm">
                <li><a href="/#recursos" className="text-gray-300 hover:text-white transition-colors">Recursos</a></li>
                <li><a href="/#como-funciona" className="text-gray-300 hover:text-white transition-colors">Como funciona</a></li>
                <li><a href="/#planos" className="text-gray-300 hover:text-white transition-colors">Planos</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-3 text-sm uppercase tracking-wider text-white/80">
                Pra fornecedores
              </h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/cadastrar" className="text-gray-300 hover:text-white transition-colors">Criar minha loja</Link></li>
                <li><Link to="/fornecedor/painel/login" className="text-gray-300 hover:text-white transition-colors">Painel da loja</Link></li>
                <li><a href="mailto:contato@reviter.com.br" className="text-gray-300 hover:text-white transition-colors">Falar com vendas</a></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-3 text-sm uppercase tracking-wider text-white/80">
                Pra revendedores
              </h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/quero-ser-revendedor" className="text-gray-300 hover:text-white transition-colors">Como funciona</Link></li>
                <li><Link to="/entrar" className="text-gray-300 hover:text-white transition-colors">Acessar área</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-3 text-sm uppercase tracking-wider text-white/80">
                Suporte
              </h3>
              <ul className="space-y-2 text-sm">
                <li><a href="#ajuda" className="text-gray-300 hover:text-white transition-colors">Central de ajuda</a></li>
                <li><a href="#termos" className="text-gray-300 hover:text-white transition-colors">Termos de uso</a></li>
                <li><a href="#privacidade" className="text-gray-300 hover:text-white transition-colors">Privacidade</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-gray-400 text-xs">
            © {year} Reviter. Todos os direitos reservados.
          </p>
          <PoweredBy variant="light" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
